import { GridRowData } from '@material-ui/data-grid';
import { MicrofenceEntity } from '../../util/enums';

export const isMicrofenceType = (microfence: GridRowData) => {
  if (!microfence) return;
  return [MicrofenceEntity.Beacon, MicrofenceEntity.Device, MicrofenceEntity.Gateway].includes(
    microfence.type,
  );
};
